export default "__VITE_PUBLIC_ASSET__15841f9f__"